import React from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { SideMenuFooterProps } from './types'

const svgMask: JSX.Element = (
  <svg
    width='25'
    height='45'
    viewBox='0 0 25 45'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_1202_21804)'>
      <g filter='url(#filter0_dd_1202_21804)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M-203 -16.4387C-209.627 -16.4387 -215 -11.0661 -215 -4.4387V46.3822C-215 53.0096 -209.627 58.3822 -203 58.3822H13C19.6274 58.3822 25 53.0096 25 46.3822V44.4289C25 43.1645 23.8389 42.2224 22.5783 42.3208C22.0576 42.3615 21.5312 42.3822 21 42.3822C9.9543 42.3822 1 33.4279 1 22.3822C1 11.3365 9.9543 2.3822 21 2.3822C21.5312 2.3822 22.0576 2.40291 22.5783 2.44357C23.8389 2.54198 25 1.59994 25 0.335503V-4.43872C25 -11.0661 19.6274 -16.4387 13 -16.4387H-203Z'
          fill='white'
        />
      </g>
    </g>
    <defs>
      <filter
        id='filter0_dd_1202_21804'
        x='-231'
        y='-28.4387'
        width='272'
        height='106.821'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood
          floodOpacity='0'
          result='BackgroundImageFix'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='8' />
        <feComposite
          in2='hardAlpha'
          operator='out'
        />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.167392 0 0 0 0 0.309457 0 0 0 0 0.640941 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_1202_21804'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite
          in2='hardAlpha'
          operator='out'
        />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.168627 0 0 0 0 0.309804 0 0 0 0 0.639216 0 0 0 0.04 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_1202_21804'
          result='effect2_dropShadow_1202_21804'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_1202_21804'
          result='shape'
        />
      </filter>
      <clipPath id='clip0_1202_21804'>
        <rect
          width='25'
          height='45'
          fill='white'
        />
      </clipPath>
    </defs>
  </svg>
)

export const SideMenuFooter: React.FC<SideMenuFooterProps> = ({ className, children }) => {
  const rootClassName = classNames(styles.sideMenuFooter, className)

  return (
    <footer className={ rootClassName }>
      { svgMask }
      { children }
    </footer>
  )
}
